export default __webpack_public_path__ + "static/media/nv3.8c91df52.PNG";